import { render, staticRenderFns } from "./TicketComp.vue?vue&type=template&id=33b4eb2a&scoped=true&"
import script from "./TicketComp.vue?vue&type=script&lang=js&"
export * from "./TicketComp.vue?vue&type=script&lang=js&"
import style0 from "./TicketComp.vue?vue&type=style&index=0&id=33b4eb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b4eb2a",
  null
  
)

export default component.exports